__turbopack_context__.v({
  "faqContainer": "home-faq-module-sass-module__ga6IQW__faqContainer",
  "homeAboutTxt": "home-faq-module-sass-module__ga6IQW__homeAboutTxt",
});
